// import BaseModelComponent from '../../../../base/base_model_component';
import BaseOptionsModel from '../base_options_model';

/**
 *
 *
 *
 */
class TouchIdComponentModel extends BaseOptionsModel {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'TouchIdComponentModel';


    /**
     *
     * @param params
     */
    init(params) {

    }
}
export default TouchIdComponentModel;